// extracted by mini-css-extract-plugin
export var category = "_ku-9";
export var categoryHeader = "_ku-e";
export var container = "_ku-0";
export var group = "_ku-a";
export var groupItems = "_ku-f";
export var groupSeparator = "_ku-j";
export var loading = "_ku-1";
export var noResults = "_ku-3";
export var placeholder = "_ku-2";
export var resultContent = "_ku-5";
export var resultIcon = "_ku-c";
export var resultItem = "_ku-g";
export var resultMeta = "_ku-8";
export var resultSubtitle = "_ku-7";
export var resultSuffix = "_ku-i";
export var resultTitle = "_ku-6";
export var resultsList = "_ku-4";
export var searchGroup = "_ku-d";
export var selected = "_ku-h";
export var subgroup = "_ku-b";